import React from "react"
import { Linking, Pressable, StyleSheet, Text } from "react-native"
import * as amplitude from "@amplitude/analytics-react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { theme } from "@common/theme/theme"

// Exportés pour les affordances d'aide contextuelles des funnels frères
// (ex. « N sessions et + : nous contacter » du configurateur stage).
export const SUPPORT_PHONE_DISPLAY = "01 89 71 82 21"
export const SUPPORT_PHONE_URL = "tel:+33189718221"

/**
 * Support affordance for the high-intent summer steps. It lives at the end of
 * each screen's scrollable content so it remains available without competing
 * with the progress header or reducing the useful viewport.
 *
 * `trackingEvent` (opt-in) lets sibling funnels reusing this banner (e.g. the
 * stage funnel) keep their own analytics namespace — default unchanged.
 * `track` lets them emit it through their own tracker (the stage funnel adds
 * the journey, the stage and the link's source to every event).
 */
const SummerHelpBanner = ({
    step,
    style,
    trackingEvent = "summer_funnel_help_clicked",
    track = amplitude.track,
}) => {
    const onHelpPress = () => {
        track(trackingEvent, { step })
        Linking.openURL(SUPPORT_PHONE_URL).catch(() => {})
    }

    return (
        <Pressable
            onPress={onHelpPress}
            accessibilityRole="link"
            accessibilityLabel={`Besoin d'aide ? Appelez le ${SUPPORT_PHONE_DISPLAY}`}
            style={({ pressed }) => [
                styles.helpBanner,
                style,
                pressed && styles.helpBannerPressed,
            ]}
        >
            <FontAwesome5
                name="phone-alt"
                solid
                size={12}
                color={theme.colors.primary}
            />
            <Text style={styles.helpText}>Besoin d'aide ?</Text>
            <Text style={styles.phoneText}>{SUPPORT_PHONE_DISPLAY}</Text>
        </Pressable>
    )
}

const styles = StyleSheet.create({
    helpBanner: {
        minHeight: 40,
        marginTop: 24,
        paddingVertical: 9,
        paddingHorizontal: 12,
        borderRadius: 10,
        backgroundColor: theme.colors.primaryLighter,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
    },
    helpBannerPressed: { opacity: 0.72 },
    helpText: {
        fontFamily: "Montserrat-Medium",
        fontSize: 12,
        color: theme.colors.primary,
    },
    phoneText: {
        fontFamily: "Montserrat-ExtraBold",
        fontSize: 12,
        color: theme.colors.primary,
        textDecorationLine: "underline",
    },
})

export default SummerHelpBanner
